import React, { useEffect, useLayoutEffect } from 'react';
import './homeScreen.css';
import {Link} from 'react-router-dom';
import AboutUs from '../AboutUs/AboutUs';
import Banner from '../Marque/Scroller';
import Footer from '../Footer/Footer';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import HomeCircle from '../Home/HomeCircle';


function HomeScreen() {

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    
    const animation = useAnimation();
    const animation2 = useAnimation();
    const [featuredRef, inView] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    const [featuredRef2, inView2] = useInView({
        triggerOnce: true,
        rootMargin: '-10px'
    });
    useEffect(() => {
        if(inView) {
            animation.start("visible")
        }
    }, [animation, inView])
    useEffect(() => {
        if(inView2) {
            animation2.start("visible")
        }
    }, [animation2, inView2])
    return (
        <div className="homeScreen">
            <div className="homeScreen__div1">
                <div className="homeScreen__div2">
                    <video autoPlay loop muted className="homeScreen__video1" src="https://videos.ctfassets.net/r8gz7fst0nwf/u0wVSQ09tzRMTGee3QoLy/cfe010111f1b4d99b22fff16e66da293/REEL_HOME.mp4" />
                </div>
            </div>
            <div className="homeScreen__div3">
                <div className="homeScreen__div4">
                    <motion.div className="homeScreen__div5">
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, staggerChildren: 0.1}}}>R</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2, staggerChildren: 0.1}}}>A</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4, staggerChildren: 0.1}}}>D</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.6, staggerChildren: 0.1}}}>I</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8, staggerChildren: 0.1}}}>U</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1, staggerChildren: 0.1}}}>S</motion.h1>
                    </motion.div>
                    <motion.div className="homeScreen__div6">
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2, staggerChildren: 0.1}}}>D</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4, staggerChildren: 0.1}}}>I</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.6, staggerChildren: 0.1}}}>G</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8, staggerChildren: 0.1}}}>I</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1, staggerChildren: 0.1}}}>T</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.2, staggerChildren: 0.1}}}>A</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.4, staggerChildren: 0.1}}}>L</motion.h1>
                    </motion.div>
                    <div className="homeScreen__div7">
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.2, staggerChildren: 0.1}}} >A</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.4, staggerChildren: 0.1}}}>G</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.6, staggerChildren: 0.1}}}>E</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 0.8, staggerChildren: 0.1}}}>N</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1, staggerChildren: 0.1}}}>C</motion.h1>
                        <motion.h1 initial={{y: 400, opacity: 0}} animate={{y: 0, opacity: 1, transition: {ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1.2, staggerChildren: 0.1}}}>Y</motion.h1>
                    </div>
                </div>
                <div className="homeScreen__div8">
                    <div className="homeScreen__div9"></div>
                    <div className="homeScreen__div10">
                        <h1 className="homeScreen__line1">We increase LTV and ROI metrics by offering smart and creative approaches according to your goals, KPIs, and strategic plan</h1>
                    </div>
                    <div className="homeScreen__div11"></div>
                </div>
                <motion.div ref={featuredRef2} animate={animation2} initial = 'hidden' variants = {{ visible: { opacity: 1, y: 0, transition: {duration: 1, ease: [0.6, 0.05, -0.01, 0.9]},}, hidden: {opacity: 0, y: 72,}}} className="homeScreen__div12">
                    <div className="homeScreen__div13">
                        <motion.div className="homeScreen__div14">
                            <h1>CUSTOM <span className="homeScreen__span">MIX</span> OF</h1>
                        </motion.div>
                        <motion.div className="homeScreen__div15">
                            <h1 className="homeScreen__line2"><span className="homeScreen__span">WEBSITE</span> SERVICES</h1>
                        </motion.div>
                    </div>
                    <div className="homeScreen__div16">
                        <div className="homeScreen__div17">
                            <h3>GOT A BRILLIANT IDEA THAT WILL SHAKE UP THE DIGITAL SKYLINE?</h3>
                        </div>
                        <div className="homeScreen__div18">
                            <h3>LET’S CHAT! <Link style={{color: "#d9d9d9"}}> VISIT AND DROP US A LINE.</Link></h3>
                        </div>
                    </div>
                </motion.div>
            </div>
            <HomeCircle />
            <AboutUs />
            <Banner />
            <Footer />
        </div>
    )
}

export default HomeScreen;
